export const Types = {
    SAVE_LIST_IMAGE_PRODUCT: 'SAVE_LIST_IMAGE_PRODUCT',
}
